// extracted by mini-css-extract-plugin
module.exports = {"info__notice":"InfoNotice_info__notice_27Iw1"};